<div class="title">
  <span class="count">{{sum}}&nbsp;</span>
  <span>{{title | translate}}</span>
  <span>{{ 'in_total' | translate }}</span>
</div>
<div class="item-holder">
  @for (item of data; track item) {
    @if (item.count > 0) {
      <div class="item" [style]="'width: ' + item.count/sum*100 + '%;'">
        <div class="bar" [class]="item.title.replace(' ', '-').replace('_', '-').toLowerCase()"></div>
      </div>
    }
  }
</div>
<div class="legend-holder">
  @for (item of data; track item) {
    @if (item.count > 0) {
      <div class="item">
        <div class="text-muted">{{item.title | translate}}</div>
        <div class="counter">
          <div [class]="item.title.replace(' ', '-').replace('_', '-').toLowerCase()"></div>
          <span>{{item.count}}</span>
        </div>
      </div>
    }
  }
</div>
<div class="icons"></div>
